<template>
  <div class="qrcode-float">
    <div class="qrcode-top">
      <div class="qrcode-icon-kf" @mouseenter="qrcodeKf=true" @mouseleave="qrcodeKf=false">
        <img :src="qrcodeKf ? luff : newLuff" alt="客服" class="qrcode-img"/>
        <div class="qrcode-icon-kf-special"></div>
        <div class="qrcode-ke-popup">
          <div class="ke-popup-arrow"></div>
          <div class="qrcode-ke-popup-content">
            <img src="@/assets/images/luff-v1.png" alt="电话" class="qrcode-ke-popup-img"/>
            <div class="qrcode-ke-phone">400-600-0115</div>
          </div>
          <p class="qrcode-ke-hotline">7*24小时客服服务热线</p>
          <div class="qrcode-ke-btn" @click="handleApply">在线申请</div>
        </div>
      </div>
<!--      <div class="qrcode-icon-wx" @mouseenter="qrcodeWx=true" @mouseleave="qrcodeWx=false">-->
<!--        <img :src="qrcodeWx ? qrcode : newQrcode" alt="二维码" class="qrcode-img"/>-->
<!--        <div class="qrcode-icon-wx-special"></div>-->
<!--        <div class="qrcode-popup">-->
<!--          <div class="ke-popup-arrow"></div>-->
<!--          <img src="@/assets/images/small-qrcode.png" alt="二维码" class="qrcode-popup-img"/>-->
<!--          <p class="qrcode-popup-sao">扫描关注</p>-->
<!--          <p class="qrcode-popup-txt">微信小程序</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="qrcode-bottom" v-show="showBackToTop" @click="scrollToTop" @mouseenter="qrcodeTop=true" @mouseleave="qrcodeTop=false">
      <img :src="qrcodeTop ? topIcon : newTopIcon" alt="顶部" class="qrcode-bottom-img"/>
    </div>
    <el-dialog class="apply-dialog" v-model="visibleDialog" width="1168px" :show-close="false"
               @close="handleClose" center append-to-body :close-on-click-modal="false">
      <template #default>
        <div class="apply-main">
          <div class="apply-main-top">
            <div class="top-title">更专业、更优质的<span style="color: #0048A9">管理体系</span>，为您提供
              <span style="color: #0048A9">更合理的解决方案!</span>
            </div>
            <div class="top-phone">立即咨询电话:<span style="color: #FD3C00;">400-001-0051</span></div>
          </div>
          <div class="apply-main-bottom">
            <div class="bottom-form-txt">
              <div class="bottom-form-item">
                <div class="form-item-img"><img src="@/assets/images/lamp.png" alt="标记"/></div>
                <div class="form-item-row">你是否正在为公司管理混乱而烦恼?</div>
              </div>
              <div class="bottom-form-item">
                <div class="form-item-img"><img src="@/assets/images/lamp.png" alt="标记"/></div>
                <div class="form-item-row">是否正在寻找一款好用不贵的管理系统?</div>
              </div>
              <div class="bottom-form-item">
                <div class="form-item-img"><img src="@/assets/images/lamp.png" alt="标记"/></div>
                <div class="form-item-row">是否还在使用Excel或OA，感觉效率低下?</div>
              </div>
              <div class="bottom-form-item">
                <div class="form-item-img"><img src="@/assets/images/pen.png" alt="标记"/></div>
                <div class="form-item-row">立即填写信息，获取<span style="color:#0048A9;">《企管帮/经营帮试用方案》</span>
                </div>
              </div>
            </div>
            <div class="bottom-form-info">
              <div class="form-info-top-txt">请留下您的联系方式。专家会在 1 个工作日内与您联系，请保持电话畅通</div>
              <el-form
                ref="formRef"
                :model="formData"
                :rules="formRules"
                label-width="120px"
              >
                <el-form-item label="企业名称：" prop="companyName">
                  <el-input v-model="formData.companyName" maxlength="20" placeholder="请输入企业名称"/>
                </el-form-item>
                <el-form-item label="您的姓名：" prop="name">
                  <el-input v-model="formData.name" maxlength="11" placeholder="请输入姓名"/>
                </el-form-item>
                <el-form-item label="您的电话：" prop="phone">
                  <el-input v-model.number="formData.phone" maxlength="11" placeholder="请输入手机号"/>
                </el-form-item>
                <el-form-item label="咨询产品：" prop="product">
                  <el-radio-group v-model="formData.product">
                    <el-radio :label="1">数字化解决方案</el-radio>
                    <el-radio :label="2">公司合作</el-radio>
                    <el-radio :label="0">其他内容</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="咨询内容：" prop="description">
                  <el-input type="textarea" v-model="formData.description" maxlength="200" placeholder="请输入"/>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="apply-btn-close" @click="handleClose">取消</div>
        <div class="apply-btn-ok" @click="handleSubmit">确定</div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {onMounted, onUnmounted, reactive, ref} from "vue";
import {ElDialog, ElForm, ElFormItem, ElInput, ElRadioGroup, ElRadio, ElMessage} from 'element-plus'
import {apply} from "@/api/apiHome";
import luff from '@/assets/images/luff.png'
import newLuff from '@/assets/images/luff_v2.png'
import qrcode from '@/assets/images/qrcode.png'
import newQrcode from '@/assets/images/qrcode_v1.png'
import topIcon from '@/assets/images/top.png'
import newTopIcon from '@/assets/images/top_v1.png'

const formRef = ref(null)
const visibleDialog = ref(false)
const showBackToTop = ref(false)
const qrcodeKf = ref(false)
const qrcodeWx = ref(false)
const qrcodeTop= ref(false)
// 表单数据
const formData = reactive({
  companyName: "",
  name: '',
  phone: '',
  product: '',
  description: ''
})
// 表单验证规则
const formRules = reactive({
  companyName: [
    {required: true, message: '请输入企业名称', trigger: 'blur'}
  ],
  name: [
    {required: true, message: '请输入姓名', trigger: 'blur'}
  ],
  phone: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    {
      pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
      message: '请输入有效的手机号码',
      trigger: 'blur'
    }
  ]
})
const handleScroll = () => {
  showBackToTop.value = window.scrollY > 400 //
}
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 平滑滚动
  })
}
const handleApply = () => {
  visibleDialog.value = true
}
const handleClose = () => {
  formRef.value?.resetFields();
  visibleDialog.value = false
}
const handleSubmit = async () => {
  await formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        const {code} = await apply(formData)
        if (code === 200) {
          ElMessage.success('保存成功！');
        }
      } catch (e) {
        ElMessage.success('保存失败！');
      } finally {
        visibleDialog.value = false
      }
    }
  })
}
// 生命周期钩子
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.qrcode-float {
  height: 180px;
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-60%);
  z-index: 10;
}

.qrcode-top {
  width: 54px;
  height: 70px;
  background: #FFFFFF;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
  border-radius: 47px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qrcode-icon-kf, .qrcode-icon-wx {
  width: 54px;
  border-radius: 47px;
  background-color: rgba(255, 255, 255, 1);
  border: none;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin-bottom: 10px;
  cursor: pointer;
  //margin-top: 21px;
}

.qrcode-icon-kf-special {
  position: absolute;
  top: -4px;
  left: -15px;
  width: 80px;
  height: 40px;
}

.qrcode-icon-kf-special:hover + .qrcode-ke-popup {
  display: block;
}

.qrcode-img {
  width: 30px;
  height: 30px;
}

.qrcode-icon-kf:hover .qrcode-ke-popup {
  display: block;
}

.qrcode-ke-popup {
  display: none;
  position: absolute;
  right: 60px;
  top: -25px;
  background: white;
  border-radius: 8px;
  margin-right: 10px;
  width: 305px;
  height: 152px;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
  box-sizing: border-box;
  padding: 22px 24px;

  .ke-popup-arrow {
    position: absolute;
    top: 35px;
    left: auto;
    right: -7px;
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid #fff;
  }
}

.qrcode-icon-wx-special {
  position: absolute;
  top: -4px;
  left: -15px;
  width: 80px;
  height: 40px;
}

.qrcode-ke-popup-content {
  display: flex;
  align-items: center;

  .qrcode-ke-popup-img {
    width: 22px;
    height: 22px;
    margin-right: 4px;
  }

  .qrcode-ke-phone {
    font-weight: bold;
    font-size: 24px;
    color: #0048A9;
  }
}

.qrcode-ke-hotline {
  font-size: 14px;
  color: #797979;
  margin-top: 8px;
  margin-bottom: 16px;
  margin-left: 26px;
}

.qrcode-ke-btn {
  width: 169px;
  height: 38px;
  line-height: 38px;
  background: #0048A9;
  border-radius: 8px;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  margin-left: 26px;
}

.qrcode-popup {
  display: none;
  position: absolute;
  width: 195px;
  height: 212px;
  right: 60px;
  top: -27px;
  background: white;
  padding: 11px 30px 16px 26px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  text-align: center;
  box-sizing: border-box;

  .ke-popup-arrow {
    position: absolute;
    top: 35px;
    left: auto;
    right: -7px;
    width: 0;
    height: 0;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 7px solid #fff;
  }
}

.qrcode-popup-sao {
  font-weight: bold;
  font-size: 14px;
  color: #0048A9;
  margin-top: 14px;
}

.qrcode-popup-txt {
  font-size: 14px;
  color: #242424;
  margin-top: 10px;
}

.qrcode-icon-wx:hover .qrcode-popup {
  display: block;
}

.qrcode-popup-img {
  width: 131px;
  height: 123px;
  object-fit: cover;
}

.qrcode-bottom {
  width: 54px;
  height: 70px;
  background: #FFFFFF;
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
  border-radius: 47px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.qrcode-bottom-img {
  width: 30px;
  height: 30px;
}

.apply-main {
  width: 100%;
  height: 622px;
  box-sizing: border-box;
  background-image: url("~@/assets/images/apply-bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  .top-title {
    padding-top: 54px;
    font-weight: bold;
    font-size: 34px;
    color: #303133;
    text-align: center;
  }

  .top-phone {
    text-align: center;
    margin-top: 25px;
    font-size: 22px;
    color: #303133;
  }
}

.apply-main-bottom {
  margin-top: 45px;
  display: flex;
  box-sizing: border-box;
}

.bottom-form-info {
  width: 611px;
  height: 389px;
  background: rgba(244, 248, 255, 0.54);
  box-shadow: 0 2px 16px 0 rgba(14, 35, 70, 0.18);
  border-radius: 8px;
  padding: 20px 34px 30px 30px;
  box-sizing: border-box;

  :deep(.el-form-item) {
    margin-bottom: 20px;
  }

  :deep(.el-textarea__inner) {
    height: 72px;
  }

  :deep(.el-input__wrapper) {
    height: 34px;
  }

  :deep(.el-form-item__label) {
    color: #242424;
  }

  :deep(.el-radio__input.is-checked .el-radio__inner:after) {
    background-color: #0048A9;
    width: 7px;
    height: 7px;
  }

  :deep(.el-radio__input.is-checked .el-radio__inner) {
    background-color: #fff;
  }

  :deep(.el-radio__input.is-checked+.el-radio__label) {
    color: #0048A9;
  }
}

.form-info-top-txt {
  font-size: 14px;
  color: #797979;
  margin-bottom: 32px;
}

.bottom-form-txt {
  margin: 48px 44px 54px 64px;
}

.bottom-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 37px;
}

.form-item-img {
  width: 34px;
  height: 34px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.form-item-row {
  font-size: 16px;
  color: #242424;
  margin-left: 14px;
}
</style>
<style lang="scss">
.apply-dialog {
  padding: 0 !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__footer {
    padding: 30px 0;
    display: flex;
    justify-content: center;
  }

  .apply-btn-close {
    width: 100px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 6px;
    font-size: 16px;
    color: #797979;
    cursor: pointer;
    border: 1px solid #DBDBDB;

    &:hover {
      opacity: 0.5;
    }
  }

  .apply-btn-ok {
    width: 100px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background: #0048A9;
    border-radius: 6px;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    margin-left: 20px;

    &:hover {
      opacity: 0.5;
    }
  }
}
</style>

